// extracted by mini-css-extract-plugin
export default {"overlay":"AC-z","bodyOpen":"BC-z","content":"CC-z","header":"DC-z","close":"EC-z","closeNoHeading":"FC-z"};